
import WarehouseIcon from '@mui/icons-material/Warehouse';


export const relationReturnsConfig = (hasReturnManagePermission) => {
    return {
       
        processedReturns: {
            title: 'processed_returns', 
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        expectedReturns: {
            title: 'expected_returns', 
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        completedReturns: {
            title: 'completed_returns', 
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        returnlines: {
            title: 'return_lines', 
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        ...(hasReturnManagePermission && {
            paidReturnsWithoutShipments:  {
                title: 'paid_returns_no_shipments',
                icon: <WarehouseIcon/>,
                isSingleDataGrid: true,
            },
        }),
        // ...(!isFulfilment && {
        //     // design: {
        //     //     title: 'design',
        //     //     icon: <WarehouseIcon/>,
        //     //     isSingleDataGrid: false,
        //     // },
        //     // returnReasons: {
        //     //     title: 'return_reasons',
        //     //     icon: <WarehouseIcon/>,
        //     //     isSingleDataGrid: true,
        //     // }
            
        // })
    };
};

